module.exports = __webpack_public_path__ + "img/pixivel.5e524461.png";